import ProjectSplash from "./ProjectSplash";
import { Link } from "react-router-dom";

function RecentWork({projects}) {

  const projectsData = projects;
  //console.log(projectsData);

  return (
    <div id="projects" className="mb-20 lg:w-2/3 md:w-3/4 sm:w-100 p-4 m-auto overflow-x-hidden">
      <h2 className="mb-5 recent-work opacity-0" >
        Recent Work
      </h2>
          <div className="mt-5">
              <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {projectsData.map((p) => (
                  <Link to={`/${p.slug}`} state = {{ project: p}}>
                    <ProjectSplash project={p}/>
                  </Link>
                ))}
            </div>
          </div>    
    </div>
  );
}

export default RecentWork;


